import type { ReactNode } from 'react';

/*
  An empty panel has to say which of three things happened: there is nothing
  here yet, your filters excluded everything, or something failed. A bare
  "No results" leaves the reader to guess, and the third case is the one where
  guessing wrong costs them.
*/

export function EmptyState({
  icon,
  title,
  description,
  action,
}: {
  icon?: ReactNode;
  title: string;
  description?: string;
  action?: ReactNode;
}) {
  return (
    <div className="flex flex-col items-center justify-center px-6 py-16 text-center">
      {icon && (
        <div className="mb-3 flex h-10 w-10 items-center justify-center rounded-lg border border-border bg-muted text-muted-foreground">
          {icon}
        </div>
      )}
      <p className="text-[12.5px] font-bold text-foreground">{title}</p>
      {description && (
        <p className="mt-1 max-w-sm text-[11px] leading-relaxed text-muted-foreground">{description}</p>
      )}
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
}
